export default {
  staff: {
    contactAdministrator: 'Please contact your administrator.',
    defaultContinue: 'Please press the button below to continue with this default.',
    memberPin: 'Team Member PIN',
    errorInactive: 'Inactive team member',
    errorInvalidPasscode: 'Invalid passcode',
    errorInvalidPin: 'Invalid PIN',
    hiName: 'Hi {n}!',
    passcode: 'Passcode',
    passcodePrompt: 'Please enter the settings passcode',
    pin: 'Enter your PIN',
    surveyContinue: 'Please press the button below to continue with this survey.',
    surveysDisabled: 'All surveys have been disabled.',
    surveySelect: 'Select another survey',
    surveySelected: 'Selected Survey',
    startSurvey: 'Start Survey'
  }
};